import React, { useEffect, useState } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { useSelector } from 'react-redux';
import InfoBox from './InfoBox';

const InfoBoxWrapper = () => {
  const { bannerBoxData } = useSelector((state) => state.productData);
  const [boxData, setBoxData] = useState([]);

  useEffect(() => {
    if (bannerBoxData && Object.keys(bannerBoxData).length) {
      const updatedData = [];
      Object.values(bannerBoxData).forEach((value) => {
        if (
          typeof value === 'object' &&
          value.title &&
          value.url &&
          value.description
        )
          updatedData.push(value);
      });
      setBoxData(updatedData);
    }
  }, [bannerBoxData]);
  return (
    <I18nProvider i18n={i18n}>
      <InfoBox boxData={boxData} />
    </I18nProvider>
  );
};

export default InfoBoxWrapper;
